import { interopDefault } from '~/router/utils'

export default [
  {
    path: '/market/cart',
    name: '__market_cart',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/marketplace/cart.vue' /* webpackChunkName: "pages-car-market-cart.vue" */
        )
      )
  },
  {
    path: '/market/cart/checkout/:userId',
    name: '__market_cart_checkout_seller',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/marketplace/checkout-seller.vue' /* webpackChunkName: "pages-car-market-cart-checkout-seller.vue" */
        )
      )
  },
  {
    path: '/market/orders/:orderId/success',
    name: '__market_order_success',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/marketplace/order-success.vue' /* webpackChunkName: "pages-car-market-order-success.vue" */
        )
      )
  },
  {
    path: '/market/terms/',
    name: '__market_terms',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/marketplace/terms.vue' /* webpackChunkName: "pages-car-market-terms.vue" */
        )
      )
  },
  {
    path: '/market/fair-use/',
    name: '__market_fair_use',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/marketplace/fair-use.vue' /* webpackChunkName: "pages-car-market-fair-use.vue" */
        )
      )
  },
  {
    path: '/market/user-data-processing/',
    name: '__market_user_data_processing',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/marketplace/user-data-processing.vue' /* webpackChunkName: "pages-car-market-user-data-processing.vue" */
        )
      )
  }
]
